/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Step_DissectInputs */

const en_site_step_dissect = /** @type {(inputs: Site_Step_DissectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dissect website`)
};

const id_site_step_dissect = /** @type {(inputs: Site_Step_DissectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedah website`)
};

/**
* | output |
* | --- |
* | "Dissect website" |
*
* @param {Site_Step_DissectInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_step_dissect = /** @type {((inputs?: Site_Step_DissectInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Step_DissectInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_step_dissect(inputs)
	return en_site_step_dissect(inputs)
});